<header class="header">
  <div class="logo">
    <img [src]="logoUrl" alt="" />    
  </div>
  <div class="appName"><h1>NGDT - {{ clientName }}</h1></div>
</header>
